<template>
  <!-- Static board foundation: background, measurement grid, and border. -->
  <rect x="0" y="0" :width="W" :height="H" class="map-bg" />

  <line
    v-for="gx in fineGridX"
    :key="'fg-x-' + gx"
    :x1="s(gx)"
    y1="0"
    :x2="s(gx)"
    :y2="H"
    class="grid-fine"
  />
  <line
    v-for="gy in fineGridY"
    :key="'fg-y-' + gy"
    x1="0"
    :y1="s(gy)"
    :x2="W"
    :y2="s(gy)"
    class="grid-fine"
  />

  <line
    v-for="gx in midGridX"
    :key="'md-x-' + gx"
    :x1="s(gx)"
    y1="0"
    :x2="s(gx)"
    :y2="H"
    class="grid-mid"
  />
  <line
    v-for="gy in midGridY"
    :key="'md-y-' + gy"
    x1="0"
    :y1="s(gy)"
    :x2="W"
    :y2="s(gy)"
    class="grid-mid"
  />

  <line
    v-for="gx in minorGridX"
    :key="'mn-x-' + gx"
    :x1="s(gx)"
    y1="0"
    :x2="s(gx)"
    :y2="H"
    class="grid-minor"
  />
  <line
    v-for="gy in minorGridY"
    :key="'mn-y-' + gy"
    x1="0"
    :y1="s(gy)"
    :x2="W"
    :y2="s(gy)"
    class="grid-minor"
  />

  <line :x1="s(30)" y1="0" :x2="s(30)" :y2="H" class="grid-major" />
  <line x1="0" :y1="s(22)" :x2="W" :y2="s(22)" class="grid-major" />

  <rect x="0" y="0" :width="W" :height="H" class="map-border" />
</template>

<script setup lang="ts">
import { W, H, s } from '../mapRender.js';

const fineGridX = Array.from({ length: 59 }, (_, i) => i + 1);
const fineGridY = Array.from({ length: 43 }, (_, i) => i + 1);
const midGridX = [7.5, 22.5, 37.5, 52.5];
const midGridY = [5.5, 16.5, 27.5, 38.5];
const minorGridX = [15, 45];
const minorGridY = [11, 33];
</script>

<style scoped>
.map-bg {
  fill: #f0f0ee;
}

.map-border {
  fill: none;
  stroke: #374151;
  stroke-width: 2;
  pointer-events: none;
}

.grid-fine,
.grid-mid,
.grid-minor,
.grid-major {
  pointer-events: none;
}

.grid-fine {
  stroke: #d2d2d2;
  stroke-width: 0.3;
  opacity: 0.4;
}

.grid-mid {
  stroke: #b4b8c2;
  stroke-width: 0.55;
  opacity: 0.5;
}

.grid-minor {
  stroke: #7a8190;
  stroke-width: 0.95;
  opacity: 0.65;
}

.grid-major {
  stroke: #3f4453;
  stroke-width: 1.6;
  opacity: 0.85;
}
</style>
